export default __webpack_public_path__ + "static/media/kitchen3-afterH.f8083d4b.jpg";